
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adventkalender/[slug]",
      function () {
        return require("private-next-pages/adventkalender/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adventkalender/[slug]"])
      });
    }
  